// src/components/AssignTechnicianModal.js
import React, { useState, useRef, useEffect } from 'react';
import { FiSearch, FiX, FiCheck } from 'react-icons/fi';

const AssignTechnicianModal = ({ isOpen, onClose, technicians, onSave, currentTechnicianIds = [] }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const overlayMousedownTarget = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setSelectedIds(currentTechnicianIds);
      setSearchTerm(''); 
    }
  }, [isOpen, currentTechnicianIds]);

  // ✅ NEW: Close on Escape Key
  useEffect(() => {
    const handleKeyDown = (e) => {
        if (e.key === 'Escape' && isOpen) {
            e.preventDefault();
            onClose();
        }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);
  
  if (!isOpen) return null;

  const filteredTechnicians = technicians.filter(tech =>
    tech.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const handleToggleSelection = (techId) => {
    setSelectedIds(prev =>
      prev.includes(techId) ? prev.filter(id => id !== techId) : [...prev, techId]
    );
  };

  const handleSave = () => {
    onSave(selectedIds);
    onClose();
  };
  
  const handleMouseDown = (e) => {
    overlayMousedownTarget.current = e.target;
  };

  const handleMouseUp = (e) => {
    if (overlayMousedownTarget.current === e.target && e.target === e.currentTarget) {
      onClose();
    }
    overlayMousedownTarget.current = null;
  };

  return (
    <div 
      className="modal-overlay" 
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <div className="modal-content modal-content-slim">
        <div className="modal-header">
          <h3 className="modal-title">Assign Technicians</h3>
          <button onClick={onClose} className="modal-close-btn"><FiX /></button>
        </div>
        <div className="modal-body">
          <div className="search-input-wrapper modal-search-wrapper">
            <FiSearch className="search-icon" />
            <input
              type="search"
              placeholder="Search by name..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div className="selection-list multi-select-list">
            {filteredTechnicians.map(tech => {
              const isSelected = selectedIds.includes(tech._id);
              return (
                <div
                  key={tech._id}
                  className={`selection-list-item ${isSelected ? 'selected' : ''}`}
                  onClick={() => handleToggleSelection(tech._id)}
                >
                  <div className="item-main-info">
                      <p className="item-title">{tech.name}</p>
                      <p className="item-subtitle">{tech.email}</p>
                  </div>
                  <div className="item-meta-info">
                      <span className={`status-badge status-${tech.status.toLowerCase().replace(' ', '-')}`}>{tech.status}</span>
                      {isSelected && <FiCheck className="selection-checkmark" />}
                  </div>
                </div>
              );
            })}
             {filteredTechnicians.length === 0 && (
                <div className="selection-list-empty">
                    <p>No technicians found matching "{searchTerm}"</p>
                </div>
            )}
          </div>
        </div>
        <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button type="button" className="btn btn-primary" onClick={handleSave}>
                Save Assignments ({selectedIds.length})
            </button>
        </div>
      </div>
    </div>
  );
};

export default AssignTechnicianModal;